import React from 'react';
import './Terms.css';

const Terms = () => {
  return (
    <div className="terms-page">
      {/* Page Header */}
      <section className="page-header">
        <div className="container">
          <h1>เงื่อนไขการใช้บริการ</h1>
          <p>ข้อกำหนดและเงื่อนไขในการใช้บริการของเรา</p>
        </div>
      </section>

      {/* Terms Content */}
      <section className="section terms-content">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="terms-card">
                <h2>เงื่อนไขการใช้บริการของ 707 M CO., LTD.</h2>
                <p className="last-updated">ปรับปรุงล่าสุด: {new Date().toLocaleDateString()}</p>
                
                <div className="terms-section">
                  <h3>1. ข้อตกลงในการใช้บริการ</h3>
                  <p>เมื่อคุณเข้าถึงและใช้งานเว็บไซต์นี้ ถือว่าคุณยอมรับและตกลงที่จะปฏิบัติตามข้อกำหนดและเงื่อนไขทั้งหมดในข้อตกลงฉบับนี้</p>
                </div>
                
                <div className="terms-section">
                  <h3>2. สิทธิ์การใช้งาน</h3>
                  <p>เรามอบสิทธิ์ให้คุณดาวน์โหลดเนื้อหาจากเว็บไซต์ของ 707 M CO., LTD. เพื่อใช้งานส่วนบุคคลในลักษณะไม่เชิงพาณิชย์ชั่วคราวเท่านั้น สิทธิ์ดังกล่าวเป็นเพียงการอนุญาตให้ใช้งาน ไม่ใช่การโอนกรรมสิทธิ์</p>
                </div>
                
                <div className="terms-section">
                  <h3>3. ข้อจำกัดความรับผิด</h3>
                  <p>เนื้อหาทั้งหมดบนเว็บไซต์ของ 707 M CO., LTD. ถูกนำเสนอในสภาพ “ตามที่เป็น” โดยบริษัทไม่มีการรับประกันใดๆ ทั้งที่เป็นลายลักษณ์อักษรหรือโดยนัย และขอปฏิเสธการรับประกันอื่นใด รวมถึงแต่ไม่จำกัดเพียงการรับประกันโดยนัยเกี่ยวกับความเหมาะสมเพื่อการพาณิชย์ ความเหมาะสมเพื่อวัตถุประสงค์เฉพาะ หรือการไม่ละเมิดทรัพย์สินทางปัญญาหรือสิทธิอื่นใด</p>
                </div>
                
                <div className="terms-section">
                  <h3>4. ข้อจำกัด</h3>
                  <p>ภายใต้สถานการณ์ใด 707 M CO., LTD. หรือผู้จัดหาของบริษัทจะไม่รับผิดชอบต่อความเสียหายใดๆ (รวมถึงแต่ไม่จำกัดเพียงความเสียหายจากการสูญหายของข้อมูลหรือผลกำไร หรือจากการหยุดชะงักของธุรกิจ) ที่เกิดจากการใช้หรือไม่สามารถใช้เนื้อหาบนเว็บไซต์ของ 707 M CO., LTD. ได้</p>
                </div>
                
                <div className="terms-section">
                  <h3>5. ความถูกต้องของข้อมูล</h3>
                  <p>เนื้อหาที่ปรากฏบนเว็บไซต์ของ 707 M CO., LTD. อาจมีข้อผิดพลาดทางเทคนิค ทางการพิมพ์ หรือด้านภาพถ่าย บริษัทไม่รับรองว่าเนื้อหาใดๆ บนเว็บไซต์มีความถูกต้อง ครบถ้วน หรือเป็นปัจจุบัน</p>
                </div>
                
                <div className="terms-section">
                  <h3>6. ลิงก์</h3>
                  <p>707 M CO., LTD. ไม่ได้ตรวจสอบเว็บไซต์ทั้งหมดที่เชื่อมโยงกับเว็บไซต์ของเรา และไม่รับผิดชอบต่อเนื้อหาของเว็บไซต์ภายนอกเหล่านั้น การมีลิงก์ไม่ได้หมายความว่าบริษัทให้การรับรองเว็บไซต์ดังกล่าว</p>
                </div>
                
                <div className="terms-section">
                  <h3>7. การแก้ไข</h3>
                  <p>707 M CO., LTD. อาจปรับปรุงเงื่อนไขการใช้บริการของเว็บไซต์ได้ตลอดเวลาโดยไม่ต้องแจ้งให้ทราบล่วงหน้า เมื่อคุณใช้เว็บไซต์นี้ ถือว่าคุณยอมรับที่จะปฏิบัติตามเงื่อนไขการใช้บริการฉบับล่าสุด</p>
                </div>
                
                <div className="terms-section">
                  <h3>8. กฎหมายที่ใช้บังคับ</h3>
                  <p>ข้อกำหนดและเงื่อนไขเหล่านี้อยู่ภายใต้และตีความตามกฎหมายของประเทศไทย และคุณตกลงที่จะยอมรับอำนาจศาลของประเทศไทยแต่เพียงผู้เดียว</p>
                </div>
                
                <div className="terms-section">
                  <h3>9. นโยบายความเป็นส่วนตัว</h3>
                  <p>ความเป็นส่วนตัวของคุณเป็นสิ่งสำคัญสำหรับเรา นโยบายความเป็นส่วนตัวของเราอธิบายวิธีการเก็บรวบรวม ใช้ และปกป้องข้อมูลของคุณเมื่อคุณใช้เว็บไซต์ของเรา เมื่อคุณใช้งานเว็บไซต์ ถือว่าคุณยอมรับการเก็บรวบรวมและการใช้ข้อมูลตามนโยบายความเป็นส่วนตัวของเรา</p>
                </div>
                
                <div className="terms-section">
                  <h3>10. ข้อมูลผลิตภัณฑ์</h3>
                  <p>707 M CO., LTD. เชี่ยวชาญด้านการจัดจำหน่ายขวดน้ำแก้วและกระติกน้ำสูญญากาศ เราพยายามอย่างเต็มที่ในการนำเสนอข้อมูลผลิตภัณฑ์ที่ถูกต้อง แต่ไม่รับประกันว่า คำอธิบายสินค้าหรือเนื้อหาอื่นใดบนเว็บไซต์จะถูกต้อง ครบถ้วน เชื่อถือได้ ทันสมัย หรือปราศจากข้อผิดพลาด</p>
                </div>
                
                <div className="terms-section">
                  <h3>11. ข้อมูลการติดต่อ</h3>
                  <p>หากมีคำถามเกี่ยวกับเงื่อนไขการใช้บริการ โปรดติดต่อเราที่:</p>
                  <ul>
                    <li>อีเมล: info@707m.co.th</li>
                    <li>โทรศัพท์: +66 2 234 5678</li>
                    <li>ที่อยู่: 968 อาคารอื้อจือเหลียง ชั้นที่ 5 ถนนพระรามที่ 4 แขวงสีลม เขตบางรัก กรุงเทพมหานคร 10500</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Terms;
